// Phase 24d · Ticket purchase success confirmation
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Ticket, Check, Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TicketPurchaseSuccess() {
    const { ticket_id } = useParams();
    const [ticket, setTicket] = useState(null);
    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${API}/api/tickets/me/${ticket_id}`, { credentials: "include" });
                if (r.ok) setTicket(await r.json());
            } catch {}
        })();
    }, [ticket_id]);
    return (
        <div className="min-h-screen bg-[#0A0A0A] text-[#FFFFFF] flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-[#111111] border border-[#1A1A1A] rounded-2xl p-6 text-center" data-testid="ticket-success">
                <div className="mx-auto w-14 h-14 rounded-full bg-[#CCCCCC]/10 flex items-center justify-center mb-4">
                    <Check className="text-[#CCCCCC]" size={28} />
                </div>
                <h1 className="text-xl font-bold">Ticket confirmed!</h1>
                <p className="text-sm text-neutral-400 mt-2">Your ticket has been reserved. A confirmation email is on its way.</p>
                {ticket && (
                    <div className="mt-5 flex flex-col items-center gap-3">
                        <img
                            data-testid="ticket-qr-img"
                            src={`${API}/api/tickets/me/${ticket.ticket_id}/qr.png`}
                            alt="Ticket QR"
                            className="w-48 h-48 bg-white p-2 rounded-lg"
                        />
                        <a
                            href={`${API}/api/tickets/me/${ticket.ticket_id}/qr.png`}
                            download={`ticket-${ticket.ticket_id}.png`}
                            className="text-xs text-[#FFFFFF] hover:underline inline-flex items-center gap-1"
                            data-testid="ticket-qr-download"
                        >
                            <Download size={12} /> Download QR
                        </a>
                    </div>
                )}
                <div className="mt-5 flex items-center justify-center gap-3">
                    <Link to="/account/tickets" data-testid="ticket-goto-mine" className="text-xs px-4 py-2 rounded-full bg-white text-black inline-flex items-center gap-1">
                        <Ticket size={12} /> My tickets
                    </Link>
                </div>
            </div>
        </div>
    );
}
